<template>
  <div>
    <p
      class="font-weight-bold mt-6 px-8"
      :class="replacement_comment && 'mb-0'"
    >
      Ersättningstrafik
    </p>
    <p class="px-8 text-body-2 text--secondary">
      {{ replacement_comment }}
    </p>
    <TrafficMessageRow :items="list" />
  </div>
</template>

<script>
import { get } from 'vuex-pathify'
import replacementTypes from '@/common/replacementTypes'
import replacementStatus from '@/common/replacementStatus'
import TrafficMessageRow from './TrafficMessageRow'
import diffFactory from '@/helpers/diffFactory'

export default {
  name: 'TrafficMessageReplacementText',

  components: {
    TrafficMessageRow
  },

  computed: {
    replacement_comment: get('trafficMessage/model@replacement_comment'),
    replacements: get('replacement/data'),
    model: get('trafficMessage/model'),
    stops: get('event/stops'),

    list() {
      const findLocationName = signature => {
        const location = this.stops.find(
          x => x.short_name === signature.toUpperCase()
        )
        return location ? location.stop_name : signature.toUpperCase()
      }

      return diffFactory(
        this.model.replacements,
        x =>
          `${replacementTypes[x.type]}, ${
            x.type === 'TRAIN_REPLACEMENT' ? x.train_number : ''
          } ${findLocationName(x.from)} - ${findLocationName(x.to)}, ${
            replacementStatus[x.status]
          }`,
        this.replacements
      )
    }
  }
}
</script>
